import anime from 'animejs';

export default function (target, collapsed, autoHeight) {
	const duration = 500;

	return anime({
		targets: target,
		height: [collapsed, autoHeight],
		direction: 'reverse',
		complete: (self) => {
			if (!self.reversed) {
				target.removeAttribute('style');
			}

			self.began = false;
			self.completed = false;
		},
		autoplay: false,
		duration,
		easing: 'easeInOutCubic',
	});
}



// WEBPACK FOOTER //
// ./scripts/sky-reveal/factories/animeInstance.js